import { render, staticRenderFns } from "./chatPolicyDialog.vue?vue&type=template&id=3e9126f7&scoped=true"
import script from "./chatPolicyDialog.vue?vue&type=script&lang=js"
export * from "./chatPolicyDialog.vue?vue&type=script&lang=js"
import style0 from "./chatPolicyDialog.vue?vue&type=style&index=0&id=3e9126f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9126f7",
  null
  
)

export default component.exports